/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Input } from '../../../../components';
import SelectDriver from './select-driver';

const ModalFilter = ({ filters, onClose, onSubmit }) => {
  const [form, setForm] = useState({
    isFilteringToPay: true,
    user_id: filters.user_id,
    since: filters.since,
    until: filters.until,
  });

  const onChange = (target, value) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  return (
    <div className="w-[30rem] mx-auto bg-white p-6 rounded-2xl font-sans antialiased selection:bg-orange-100 relative">
      <button
        type="button"
        className="p-1.5 rounded-full hover:bg-gray5 transition-colors absolute top-2 right-2"
        onClick={onClose}
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>

      <div className="mb-4">
        <h3 className="text-xl text-center font-bold mb-4 text-gray-900">Filtro para pagar</h3>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div className="col-span-2">
          <p className="mb-1 text-text">Nombre de conductor</p>
          <SelectDriver
            value={form.user_id}
            selectedLabel={form?.user?.person?.fullName}
            onSelect={item => {
              onChange('user_id', item?.id);
              onChange('user', item);
            }}
          />
        </div>

        <Input
          type="date"
          label="Desde"
          value={form.since}
          onValueChange={v => onChange('since', v)}
        />

        <Input
          type="date"
          label="Hasta"
          value={form.until}
          onValueChange={v => onChange('until', v)}
        />
      </div>

      <div className="flex justify-center items-center gap-6 mt-8">
        <button className="text-black font-bold" onClick={onClose}>
          Cerrar
        </button>

        <button
          className="bg-red text-white font-bold transition-all duration-200 disabled:bg-gray5 disabled:text-gray6 px-8 py-1 rounded-full"
          onClick={() => {
            onSubmit({ ...form, owner: undefined });
            onClose();
          }}
          disabled={!form.user_id || !form.since || !form.until}
        >
          Filtrar
        </button>
      </div>
    </div>
  )
}

export default ModalFilter;